// store/Plans/PlansSaga.js
import { put, call, takeLatest } from "redux-saga/effects";
import * as api from "./api";
import * as actionTypes from "../ActionTypes";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

/* ================= SAVE PLAN ================= */
function* savePlanSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload;


    const response = yield call(api.savePlanAPI, payload);

    yield put({
      type: actionTypes.SAVE_PLAN_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message || err.message;


    yield put({
      type: actionTypes.SAVE_PLAN_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= UPDATE PLAN ================= */
function* updatePlanSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload;
    const response = yield call(api.updatePlanAPI, payload);

    yield put({
      type: actionTypes.UPDATE_PLAN_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;

    yield put({
      type: actionTypes.UPDATE_PLAN_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= READ PLAN ================= */
function* readPlanSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload || {};


    const response = yield call(api.readPlanAPI, payload);

    yield put({
      type: actionTypes.READ_PLAN_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response.data });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message || err.message;


    yield put({
      type: actionTypes.READ_PLAN_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= SAVE DAY PLAN ================= */
function* saveDayPlanSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload;


    const response = yield call(api.saveDayPlanAPI, payload);

    yield put({
      type: actionTypes.SAVE_DAY_PLAN_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message || err.message;


    yield put({
      type: actionTypes.SAVE_DAY_PLAN_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= UPDATE DAY PLAN ================= */
function* updateDayPlanSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload || {};


    const response = yield call(api.updateDayPlanAPI, payload);

    yield put({
      type: actionTypes.UPDATE_DAY_PLAN_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;


    yield put({
      type: actionTypes.UPDATE_DAY_PLAN_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= UPDATE DAY PLAN PROGRESS ================= */
function* updateDayPlanProgressSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload || {};


    const response = yield call(api.updateDayPlanProgressAPI, payload);

    yield put({
      type: actionTypes.UPDATE_DAY_PLAN_PROGRESS_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response?.data || response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;


    yield put({
      type: actionTypes.UPDATE_DAY_PLAN_PROGRESS_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= DELETE DAY PLAN ================= */
function* deleteDayPlanSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload || {};


    const response = yield call(api.deleteDayPlanAPI, payload);

    yield put({
      type: actionTypes.DELETE_DAY_PLAN_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;


    yield put({
      type: actionTypes.DELETE_DAY_PLAN_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= SAVE DAY PLAN DETAILS ================= */
function* saveDayPlanDetailsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload || {};


    const response = yield call(api.saveDayPlanDetailsAPI, payload);

    yield put({
      type: actionTypes.SAVE_DAY_PLAN_DETAILS_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;


    yield put({
      type: actionTypes.SAVE_DAY_PLAN_DETAILS_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= UPDATE DAY PLAN DETAILS ================= */
function* updateDayPlanDetailsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload || {};


    const response = yield call(api.updateDayPlanDetailsAPI, payload);

    yield put({
      type: actionTypes.UPDATE_DAY_PLAN_DETAILS_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;


    yield put({
      type: actionTypes.UPDATE_DAY_PLAN_DETAILS_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= DELETE DAY PLAN DETAILS ================= */
function* deleteDayPlanDetailsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload || {};


    const response = yield call(api.deleteDayPlanDetailsAPI, payload);

    yield put({
      type: actionTypes.DELETE_DAY_PLAN_DETAILS_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;


    yield put({
      type: actionTypes.DELETE_DAY_PLAN_DETAILS_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= CREATE YOUTUBE PLAN ================= */
function* createYoutubePlanSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload || {};


    const response = yield call(api.createYoutubePlanAPI, payload);

    yield put({
      type: actionTypes.CREATE_YOUTUBE_PLAN_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;


    yield put({
      type: actionTypes.CREATE_YOUTUBE_PLAN_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= READ USER PLANS ================= */
function* readUserPlansSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback } = action.payload || {};


    const response = yield call(api.readUserPlansAPI);

    yield put({
      type: actionTypes.READ_USER_PLANS_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response?.data || [] });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;


    yield put({
      type: actionTypes.READ_USER_PLANS_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= READ FOLLOWED ENTITY PLANS ================= */
function* readFollowedEntityPlansSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback } = action.payload || {};


    const response = yield call(api.readFollowedEntityPlansAPI);

    yield put({
      type: actionTypes.READ_FOLLOWED_ENTITY_PLANS_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response?.data || [] });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;


    yield put({
      type: actionTypes.READ_FOLLOWED_ENTITY_PLANS_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= READ USER SERMON STUDY JOBS ================= */
function* readUserSermonStudyJobsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload || {};


    const response = yield call(api.readUserSermonStudyJobsAPI, payload);

    yield put({
      type: actionTypes.READ_USER_SERMON_STUDY_JOBS_SUCCESS,
      payload: response,
    });

    callback?.({
      type: 1,
      data: response?.data,
      totalRecords: response?.totalRecords,
      page: response?.page,
      limit: response?.limit,
    });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;


    yield put({
      type: actionTypes.READ_USER_SERMON_STUDY_JOBS_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= RESET SERMON STUDY RETRY ================= */
function* resetSermonStudyRetrySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, jobId } = action.payload || {};
    const response = yield call(api.resetSermonStudyRetryAPI, jobId);

    yield put({
      type: actionTypes.RESET_SERMON_STUDY_RETRY_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response?.data || response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;

    yield put({
      type: actionTypes.RESET_SERMON_STUDY_RETRY_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= READ TWG PLANS ================= */
function* readTwgPlansSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, typeonplans = [1, 2] } = action.payload || {};


    const normalizedTypes = Array.isArray(typeonplans) && typeonplans.length
      ? typeonplans
      : [1, 2];

    const responses = [];
    for (const typeonplan of normalizedTypes) {
      const response = yield call(api.readPlanAPI, { typeonplan });
      responses.push(response);
    }

    const combinedData = responses
      .flatMap((response) =>
        Array.isArray(response?.data)
          ? response.data
          : response?.data
          ? [response.data]
          : []
      )
      .filter(
        (item, index, array) =>
          array.findIndex((candidate) => candidate?._id === item?._id) === index
      );

    const mergedResponse = {
      data: combinedData,
    };

    yield put({
      type: actionTypes.READ_TWG_PLANS_SUCCESS,
      payload: mergedResponse,
    });

    callback?.({ type: 1, data: combinedData });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err.message;


    yield put({
      type: actionTypes.READ_TWG_PLANS_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= WATCHER ================= */
export default function* PlansWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_PLAN_REQUEST, savePlanSaga);
  yield takeLatest(actionTypes.UPDATE_PLAN_REQUEST, updatePlanSaga);
  yield takeLatest(actionTypes.READ_PLAN_REQUEST, readPlanSaga);
  yield takeLatest(actionTypes.SAVE_DAY_PLAN_REQUEST, saveDayPlanSaga);
  yield takeLatest(actionTypes.UPDATE_DAY_PLAN_REQUEST, updateDayPlanSaga);
  yield takeLatest(
    actionTypes.UPDATE_DAY_PLAN_PROGRESS_REQUEST,
    updateDayPlanProgressSaga
  );
  yield takeLatest(actionTypes.DELETE_DAY_PLAN_REQUEST, deleteDayPlanSaga);
  yield takeLatest(
    actionTypes.SAVE_DAY_PLAN_DETAILS_REQUEST,
    saveDayPlanDetailsSaga
  );
  yield takeLatest(
    actionTypes.UPDATE_DAY_PLAN_DETAILS_REQUEST,
    updateDayPlanDetailsSaga
  );
  yield takeLatest(
    actionTypes.DELETE_DAY_PLAN_DETAILS_REQUEST,
    deleteDayPlanDetailsSaga
  );
  yield takeLatest(
    actionTypes.CREATE_YOUTUBE_PLAN_REQUEST,
    createYoutubePlanSaga
  );
  yield takeLatest(actionTypes.READ_USER_PLANS_REQUEST, readUserPlansSaga);
  yield takeLatest(
    actionTypes.READ_FOLLOWED_ENTITY_PLANS_REQUEST,
    readFollowedEntityPlansSaga
  );
  yield takeLatest(
    actionTypes.READ_USER_SERMON_STUDY_JOBS_REQUEST,
    readUserSermonStudyJobsSaga
  );
  yield takeLatest(
    actionTypes.RESET_SERMON_STUDY_RETRY_REQUEST,
    resetSermonStudyRetrySaga
  );
  yield takeLatest(actionTypes.READ_TWG_PLANS_REQUEST, readTwgPlansSaga);
}
